var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "business-fundamentals row" }, [
    _c(
      "div",
      { staticClass: "col-default-7 col-v-tablet-12" },
      [
        _c("scheme", {
          attrs: { value: _vm.item },
          on: { input: _vm.changeItem },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-default-5 col-v-tablet-12" }, [
      _c(
        "div",
        { staticClass: "business-fundamentals__description" },
        [
          _c("div", {
            staticClass: "business-fundamentals__name",
            domProps: {
              innerHTML: _vm._s(
                _vm.data[_vm.item] ? _vm.data[_vm.item].name : ""
              ),
            },
          }),
          _vm._v(" "),
          _vm.data[_vm.item] && _vm.data[_vm.item].title
            ? _c("div", {
                staticClass: "business-fundamentals__title",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.data[_vm.item] ? _vm.data[_vm.item].title : ""
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.data[_vm.item] && _vm.data[_vm.item].items
            ? _c(
                "z-list",
                { attrs: { tag: "ul" } },
                _vm._l(_vm.data[_vm.item].items, function (item, idx) {
                  return _c("z-list-item", {
                    key: idx,
                    domProps: { innerHTML: _vm._s(item) },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }